'use client';

import { infoList } from '@mage-ui/styled-system/recipes';

export const InfoList = ({ data, className, ...props }) => {
	return (
		<ul className={className} {...props}>
			{data
				.filter((item) => item?.fields?.value || item?.value)
				.map(
					(item) =>
						item?.value && (
							<li
								key={item?.meta?.key || item?.key}
								className={infoList().root}
							>
								<div className={infoList().row}>
									<div className={infoList().columnLeft}>
										{item?.fields?.name || item?.name}
									</div>
									<div className={infoList().columnRight}>
										<strong>{item?.fields?.value || item?.value}</strong>
									</div>
								</div>
							</li>
						),
				)}
		</ul>
	);
};
